import { render, staticRenderFns } from "./IronWorksTable.vue?vue&type=template&id=17c67e8e&"
import script from "./IronWorksTable.vue?vue&type=script&lang=js&"
export * from "./IronWorksTable.vue?vue&type=script&lang=js&"
import style0 from "./IronWorksTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports